<template>
  <div class="flex flex-column h-100vh">
    <header-component   pageType="fixed-write" :menuIndex="2"/>
    <div class="announcement flex flex-justify-center flex-1">
      <ul class="menu flex flex-column ">
        <li v-for="(item, index) in menuList" :key="index" :class="{active: menuIndex === index}" @click="menuIndex = index">{{ $t(item) }}</li>
      </ul>
      <!-- <div class="line"></div> -->
      <div class="flex flex-column content">
        <div class="title1">{{ $t('announcement.title') }}</div>
        <div class="txt1">{{ $t('announcement.content') }}</div>
        <div class="title2">{{ $t('announcement.tipsTitle') }}</div>
        <div class="txt2">
          <div v-for="(item, index) in tips" :key="'tip'+index" v-html="item"></div>
        </div>
        <div class="line"></div>
        <img src="@/assets/image/announcement/Slice 52@2x (1).png"/>
        <div class="title1">{{ $t('announcement.normalProcessTitle') }}</div>
        <div class="title2">
          <div v-for="(item, index) in warning" :key="'warn'+index" v-html="item"></div>
        </div>
        <div class="txt3">
          <div v-for="(item, index) in process" :key="'proc'+index" v-html="item"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {openRandomLink} from '@/utils'
export default {
  name: 'announcementPage',
  data() {
    return {
      menuIndex: 0,
      // menuList: ['官方公告', '功能简介']
      menuList: ['announcement.menu.0']
    }
  },
  computed: {
    tips() {
      return this.$t('announcement.tips')
    },
    warning() {
      return this.$t('announcement.warning')
    },
    process() {
      return this.$t('announcement.process')
    }
  },
  methods: {
    openRandomLink: openRandomLink
  }
}
</script>
<style lang="less" scoped>
/** ::v-deep .header{
  &::before{
    content: '';
    position: absolute;
    bottom: -1px;
    width: 100%;
    height: 1px;
    
  }
} **/
.announcement{
  padding: 90px 0 0;
  overflow: hidden;
  .menu{
    margin-right: 128px;
    margin-top: 100px;
    li{
      font-weight: 800;
      font-size: 18px;
      color: #A2A3A5;
      position: relative;
      line-height: 25px;
      text-indent: 5px;
      margin-bottom: 24px;
    }
    .active{
      font-size: 24px;
      color: #000000;
      font-weight: 900;
    }
  }
  .line{
    width: 1px;
    height: 100%;
    background-color: #00D2D2;
  }
  ::-webkit-scrollbar {
    display: none;
  }
  .content{
    width: 1216px;
    padding:0 0 0 72px;
    padding-top: 72px;
    overflow-y: scroll;
    padding-bottom: 50px;

    .title1{
      font-family: Inter, Inter;
      font-weight: bold;
      font-size: 20px;
      color: #939FDA;
      line-height: 30px;
      margin: 28px 0;
    }
    .txt1{
      font-family: Inter, Inter;
      font-weight: 500;
      font-size: 24px;
      color: #51545A;
      line-height: 43px;
      margin-bottom: 18px;
    }
    .title2{
      font-family: Inter, Inter;
      font-weight: bold;
      font-size: 46px;
      color: #000000;
      line-height: 69px;
      margin-bottom: 18px;
      &>div{
        display: flex;
        align-items: center;
        span{
          text-decoration: underline;
          color: #0865FE;
          cursor: pointer;
        }
      }
    }
    .txt2{
      font-family: Inter, Inter;
      font-weight: 500;
      font-size: 22px;
      color: #51545A;
      line-height: 40px;
      background: #F8F8F8;
      border-radius: 10px 10px 10px 10px;
      padding: 33px 49px;
      &>div{
        display: flex;
        align-items: center;
        span{
          color: #FF3E13;
        }
      }
    }
    .line{
        width: 100%;
        height: 0px;
        border-bottom: 1px solid #D3D3D3;
        margin: 30px 0;
    }
    .txt3{
      font-family: Inter, Inter;
      font-weight: 500;
      font-size: 24px;
      color: #51545A;
      line-height: 43px;
      &>div{
        display: flex;
        align-items: center;
        span{
          color: #BEC7FF;
        }
      }
    }
  }
}
</style>